
import { connect } from 'react-redux';
import { compose, branch, renderNothing } from 'recompose';


export const withAction = (target, type) => 
	compose(
		connect(({ auth }) => ({
			user: auth.user,
		})),
		branch(
			({ user }) => user && user.permission && user.permission[target] < type,
			renderNothing
		)
	);